import React from 'react';
import trans from '../../translations.json';
import './onThisPage.scss';

const OnThisPage = (props) => (
  <div className="ontario-margin-top-32-! ontario-margin-bottom-16-!">
    <h2>{trans.otp.title[props.lang]}</h2>
    <ul id="onThisPage">
      {props.sections.map((section, idx) => {
        return (
          <li key={idx}>
            <a href={section.href}>
              {trans[section.category][section.text][props.lang]}
            </a>
            {props.sections.length !== idx + 1 && <span>|</span>}
          </li>
        );
      })}
    </ul>
  </div>
);

export default OnThisPage;
